import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { Book } from '../../../../../data/book/data-types'

type BookProps = {
    book: Book
    onClick: () => void
}

const availableFlags = ['cs', 'da', 'de', 'en', 'es', 'fr', 'id', 'it', 'nl', 'no', 'pl', 'pt', 'pt-br', 'ro', 'ru', 'sv', 'uk', 'zh-cn', 'zh-tw']

const BookRow: React.FunctionComponent<BookProps> = ({ book, onClick }) => (
    <Container onClick={onClick}>
        <Image src={book.image || ""} alt={book.title || ""}/>
        <Main>
            <Title>{book.title}</Title>
            <Authors>{book.authors?.map(a => a.name || a).join(', ')}</Authors>
        </Main>
        <Description>{
            (book.synopsys?.length || 0 ) > 300
            ? book.synopsys?.slice(0, 300) + "..."
            : book.synopsys
        }</Description>
        <Flag>
            { availableFlags.includes(book.ISBN_language?.toLowerCase() || "") &&
                <Icon src={require(`./images/flags/ic_${book.ISBN_language?.toLowerCase()}.svg`)} alt={""}/>
            }
        </Flag>
    </Container>
)

const Container = styled.div`
    display: grid;
    grid-template-columns: 67px 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    align-items: flex-start;
    
    width: 100%;
    padding: 32px;

    background: ${p => p.theme.colors.bg};
    border-radius: 10px;

    cursor: pointer;

    ${up('tablet')} {
        grid-template-columns: 100px 1fr 24px;
        grid-column-gap: 32px;
    }
`

const Image = styled.img`
    width: 100%;
    grid-column: 1;
    grid-row: 1;

    border-radius: 10px;

    ${up('tablet')} {
        grid-row: 1 / span 2;
    }
`

const Main = styled.div`
`

const Title = styled.div`
    color: ${p => p.theme.colors.hushed};
    font-size: 16px;
    line-height: 28px;
    font-weight: bold;
`

const Authors = styled.div`
    color: ${p => p.theme.colors.hused};
    font-size: 16px;
    line-height: 28px;
`

const Description = styled.div`
    grid-column: 1 / span 2;

    color: ${p => p.theme.colors.secondary};
    font-size: 14px;
    line-height: 24px;

    ${up('tablet')} {
        grid-column: auto;
    }
`

const Flag = styled.div`
    display: grid;

    ${up('tablet')} {
        grid-column: 3;
        grid-row: 1 / span 3;
    }
`

const Icon = styled.img`
    width: 24px;
    
    filter: drop-shadow(0px 1px 3px rgba(16, 24, 40, 0.1)) drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.06));
    border-radius: 5px;
`

export default BookRow